<template>
    <div>
        <!-- loading spinner -->
        <div v-if="loading" id="preview-file-loading">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div>Loading files...</div>
        </div>
        <div v-else>
            <div v-if="s3files.length == 0">No files to show</div>
            <div v-else>
                <!-- new task button -->
                <div id="upload-new-file-button-container">
                    <b-input-group>
                        <b-button id="upload-new-file-button" variant="primary" size="sm" @click="uploadNewFile" class="action-button" v-b-modal="'upload-file-modal'" disabled>                    
                            <i class="fa-solid fa-plus"></i><span style="padding-left: 10px;">Upload File</span>
                        </b-button>
                    </b-input-group>
                </div>
                <div class="table-search-reports">
                    <div style="padding-right: 10px;">
                        <b-input-group size="sm"><template #prepend><b-input-group-text>Show</b-input-group-text></template>
                            <b-form-select v-model="filesPerPage">
                                <option value="5">5 Items</option>
                                <option value="10">10 Items (Default)</option>
                                <option value="20">20 Items</option>
                                <option value="50">50 Items</option>
                            </b-form-select>
                        </b-input-group>
                    </div>
                    <div>
                        <b-input-group id="search-box-container" size="sm" style="padding-right: 10px;">
                            <template #prepend>
                                <b-input-group-text>Search</b-input-group-text>
                            </template>
                            <b-input v-model="filesTableFilter" placeholder="Search for a file..."></b-input>
                        </b-input-group>
                    </div>
                </div>
                <b-table id="reportsTable" ref="selectableReportsTable" class="clickable" responive="sm" hover
                    :total-rows="totalRowsFilesTable"
                    :items="s3files"
                    :fields="filesTableFields"
                    :filter="filesTableFilter"
                    :per-page="filesPerPage"
                    :current-page="currentPageFiles"
                    @row-clicked="filesRowClicked($event)"
                    @filtered="filesTableFiltered"
                    @sort-changed="filesTableSortChanged">
                    <template #cell(download)="data"><b-button @click="downloadButtonClicked(data.item, $event)" variant="success" size="sm"><i class="fa-solid fa-download"></i></b-button></template>
                    <template #cell(size)="data"><span v-html="formatBytes(data.value)"></span></template>
                </b-table>

                <div id="reports-table-navigation" class="reports-pagination-table">
                    <div class="pagination-element-reports">
                        <!-- Pagination for the table -->
                        <b-pagination aria-controls="reportsTable" v-model="currentPageFiles" :per-page="filesPerPage" :total-rows="totalRowsFilesTable" align="right" size="sm"></b-pagination>
                    </div>
                </div>
                <b-button @click="downloadAll" variant="success" size="sm"><i class="fa-solid fa-download" style="margin-right: 10px;"></i>Download All</b-button>
                
            </div>
        </div>

        <!-- Preview File Modal -->
        <b-modal ref="previewModal" size="xl" centered>
            <div>
                <h3>{{previewFile.Key}}</h3>
                <!-- loading spinner -->
                <div v-if="!previewUrl" id="preview-file-loading">
                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                    <div>Loading file...</div>
                </div>
                <div v-if="previewUrl"><iframe :src="previewUrl" width="100%" height="600px"></iframe></div>               
            </div>
        </b-modal>

        <!-- uplaod file modal -->
        <b-modal ref="upload-file-modal" hide-footer title="Upload File" size="xl" >
            <!-- loading spinner -->
            <div v-if="uploadingFile" id="upload-file-loading">
                <div class="lds-facebook"><div></div><div></div><div></div></div>
                <div>Uploading file(s)...</div>
            </div>
            
            <div v-else id="upload-file-modal-contents">
                <b-form-group
                    label-cols-lg="2"
                    label="File Details"
                    label-size="lg"
                    label-class="font-weight-bold pt-0"
                    class="mb-10">                    
                    <b-form-group
                        label="Report Type:"
                        label-for="report-type-input"
                        label-cols-sm="12"
                        label-align-sm="top">
                        <b-form-select id="report-type-input" :options="['Neo Audit', 'Transport Report']" v-model="reportType" style="max-width: 30%;"></b-form-select>
                    </b-form-group>
                    <b-form-group
                        label="File:"
                        label-for="file-input"
                        label-cols-sm="12"
                        label-align-sm="top">
                        <b-form-file id="file-input" v-model="newFile" style="max-width: 30%;" :state="Boolean(newFile)" placeholder="Choose a file or drop it here..."></b-form-file>
                    </b-form-group>
                </b-form-group>
            </div>
            <b-button variant="primary" :disabled="Boolean(!newFile || !reportType)" style="float:right;" @click.stop="uploadFile">
                <i :class="'fa-solid fa-' + (!uploadingFile ? 'upload' : 'circle-notch fa-spin')"></i> {{ (!uploadingFile ? 'Upload' : 'Uploading') }}
            </b-button>
        </b-modal>
    </div>
</template>

<script>

import AWS from 'aws-sdk';
import moment from 'moment';
import JSZip from 'jszip';

const zipper = new JSZip();

export default {
    name: "ReportsContent",
    components: {  },
    data: function () {
        return {
            loading: true,
            bucketName: 'huonreports',
            previewFile: {},
            previewUrl: '',
            s3files: [],
            selectedFiles: [],
            selectAll: false,

            newFile: null,
            reportType: '',
            uploadingFile: false,

            filesTableFields: [
                { key: 'download', label: 'Download', thStyle: {'width': '20px', 'float': 'center'} },
                { key: 'Key', label: 'File Name', sortable: true, },
                { key: 'LastModified', label: 'Last Modified', sortable: true, },
                { key: 'Size', label: 'Size', sortable: true, },
            ],
            currentPageFiles: 1,
            totalRowsFilesTable: 0,
            filesTableFilter: '',
            filesPerPage: 10,
        };
    },
    props: {
    },
    created: function () {
        this.selectedFiles = [];

        this.fetchFilesFromS3();
    },
    mounted: function () {
        console.log("Mounted reports page")
    },
    methods: {
        async fetchFilesFromS3() {
            this.loading = true;
            const S3 = require('aws-sdk/clients/s3');
            const s3 = new S3(AWS.config);

            const params = { Bucket: this.bucketName, };

            try {
                const data = await s3.listObjectsV2(params).promise();
                
                for (var i = 0; i < data.Contents.length; i++) {
                    var file = data.Contents[i];
                    file.LastModified = moment(file.LastModified).fromNow()
                }
                this.s3files = data.Contents;
                this.totalRowsFilesTable = this.s3files.length;
            }
            catch (error) {
                console.error('Error fetching files:', error);
            }
            
            this.loading = false;
        },
        async downloadFile(file) {
            const downloadFileURL = await this.getPreSignedURL(file.Key)
            window.open(downloadFileURL);
        },
        async downloadAll() {
            this.loading = true;
            var preSignedURLs = [];
            console.log("Downloading all files...")

            console.log("Generating file Pre-Signed URLs from S3...")
            for (var i = 0; i < this.s3files.length; i++) { 
                preSignedURLs.push(await this.getPreSignedURL(this.s3files[i].Key));
            }            
        
            console.log("Adding files to Zip...")
            const urlPromises = preSignedURLs.map(async (url) => {
                const response = await this.$http(url, { responseType: 'arraybuffer' });
                const fileName = decodeURIComponent(url.split('/')[url.split('/').length - 1].split('?')[0]);
                zipper.file(fileName, response.data);
            });

            await Promise.all(urlPromises);

            console.log("Downloading zip...")
            const content = await zipper.generateAsync({ type: 'blob' });
            const blobUrl = URL.createObjectURL(content);
            const link = document.createElement('a');
            link.href = blobUrl;
            const date = new Date();
            const formattedDate = `${date.getFullYear()}${('0' + (date.getMonth() + 1)).slice(-2)}${('0' + date.getDate()).slice(-2)}`;
            link.download = `HuonReports-${formattedDate}.zip`;
            link.click();

            console.log("Downloaded all files...")
            this.loading = false;
        },
        async downloadButtonClicked(file) {
            this.loading = true;
            await this.downloadFile(file);
            this.loading = false;
        },
        uploadNewFile(){
            console.log("Upload file button clicked...")
            this.$refs['upload-file-modal'].show();
        },
        async uploadFile(){
            this.uploadingFile = true;
            console.log("Upload file initiated: ", this.newFile)

            const S3 = require('aws-sdk/clients/s3');
            const s3 = new S3(AWS.config);

            const params = { Bucket: this.bucketName, Key: this.newFile.name, Body: this.newFile };
            s3.upload(params, function(err, data){
                console.log(err, data);
            });

            await setTimeout(() => {
                // reload files list
                this.fetchFilesFromS3();
                // Make it looks like the file is loading
                this.uploadingFile = false;
                this.newFile = null;
                this.reportType = null;
                this.$refs['upload-file-modal'].hide();
            }, 500);            
        },
        formatBytes(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat(bytes / Math.pow(k, i)).toFixed(1) + ' ' + sizes[i];
        },
        isImage(fileName) {
            return /\.(jpg|jpeg|png|gif|bmp)$/.test(fileName.toLowerCase());
        },
        isPDF(fileName) {
            return /\.(pdf)$/.test(fileName.toLowerCase());
        },
        isExcel(fileName) {
            return /\.(xls)$/.test(fileName.toLowerCase());
        },
        async getPreSignedURL(fileKey) {
            // Create an S3 client instance
            const S3 = require('aws-sdk/clients/s3');
            const s3 = new S3();

            return new Promise((resolve, reject) => {
                s3.getObject({ Bucket: this.bucketName, Key: fileKey }, (err/*, data*/) => {
                    if (err) {
                        console.log("Errored: " + err)
                        reject(err);
                    } else {
                        // Generate a temporary object URL for the PDF
                        const objectUrl = s3.getSignedUrl('getObject', {
                            Bucket: this.bucketName,
                            Key: fileKey,
                            Expires: 60 * 10 // URL expires in 10 mins
                        });
                        console.log("Retrieved URL from S3: ", objectUrl)
                        this.previewUrl = objectUrl
                        resolve(objectUrl);
                    }
                });
            });
        },
        async filesRowClicked(file) {
            this.previewFile = file;
            this.previewUrl = this.getPreSignedURL(file.Key)
            this.$refs.previewModal.show();
         },
        filesTableFiltered() { },
        filesTableSortChanged() { },
    }
};
</script>

<style>
.table-search-reports {
    display: flex;
    justify-content: flex-end;
    position: relative;
    float: right;
    top: 10px;
    min-width: 90%;
}

.pagination-element-reports {
    position: relative;
    float: right;
    min-width: 40%;
}

#search-box-container { padding-right: 0; }
.clickable { cursor: pointer }

#search-box-container { padding-right: 10px; }
#upload-new-file-button-container {  float:right; padding-right: 10px; } 

@media (max-width: 767px) {

    .reports-pagination-table {
        float: left;
        padding-left: 10px;
        min-width: 100%;
    }

    .table-search-reports {
        float: right;
        min-width: 100%;
        max-width: 100%;
        font-size: .5em;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    #upload-new-file-button-container {
        position: absolute;
        right: 5px;
        top: 98px;            
    }

}

</style>